import React, { useCallback, useEffect, useState } from "react";
import { images } from "../../Images/Svg";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import style from "./CaseSearch.module.css";
import TableComponent from "../../CommonComponents/Table";
import { CaseSearchData } from "../../constants/caseSearchData";
import {
  caseSearchDataReducer,
  storeCaseIdCaseSearchReducer,
} from "../../Redux/Slice/CaseSearchSlice/caseSearchSlice";
import { useDispatch, useSelector } from "react-redux";
import CommonButton from "../../CommonComponents/CommonButton";
import { caseSearchApi } from "../../Services/caseSearch.service";
import useToaster from "../../customHook/useToaster";
import TableSkeleton from "../../CommonComponents/TableSkeleton";
import {
  searchIsAssigned,
  searchReducer,
  setPage,
} from "../../Redux/Slice/SearchSlice";
const { backArrowBold, alert, rightArrow } = images;

const selectValueKeyMap = {
  "Claim No": "claimNumber",
  "Case No": "caseNumber",
  "Policy No": "policyNumber",
};

function CaseSearchTable() {
  const [count, setCount] = useState(0);
  const [searchTableData, setSearchTableData] = useState([]);
  const [showSkeleton, setShowSkeleton] = useState(false);
  const navigate = useNavigate();
  const rowsPerPage = 10;
  const dispatch = useDispatch();
  const { showToast } = useToaster();
  const onBackClick = (e) => {
    navigate(-1);
    dispatch(caseSearchDataReducer(""));
  };

  const { searchDetails } = useSelector((state) => state?.SearchSlice);

  let { searchValue, searchSource, searchType, page } = useSelector(
    (state) => state.SearchSlice
  );

  const firstButtonClicked = useCallback(() => {
    dispatch(setPage(1));
  }, []);
  const lastButtonClicked = useCallback(() => {
    dispatch(setPage(Math.ceil(count / rowsPerPage)));
  }, [rowsPerPage, count]);
  const handleNextButtonClick = useCallback(() => {
    dispatch(setPage((page) => page + 1));
  }, []);
  const handleBackButtonClick = useCallback(() => {
    dispatch(setPage((page) => page - 1));
  }, []);
  const onPageDropdownChange = useCallback((e) => {
    dispatch(setPage(Number(e.target.value)));
  }, []);
  const onViewClick = useCallback((caseId, status, isAssigned) => {
    dispatch(storeCaseIdCaseSearchReducer(caseId));
    dispatch(caseSearchDataReducer(status));
    navigate("/caseSearchView", { state: { isAssigned, fromSearch: true } });
  });

  const searchApicall = useCallback((source, type, value, page) => {
    const selectedKey = selectValueKeyMap[type];
    const offset = (page - 1) * rowsPerPage;
    caseSearchApi({
      offset,
      limit: rowsPerPage,
      [selectedKey]: value,
      sourceSystem: source?.toLocaleLowerCase(),
    })
      ?.then((data) => {
        setShowSkeleton(false);
        if (data?.success) {
          dispatch(searchReducer(data?.data));
          let searchDetails = data?.data;
          let newData = searchDetails?.caseList?.map((item, index) => ({
            ...item,
            srNo: offset + index + 1,
            view: (
              <CommonButton
                sx={{
                  fontSize: "10px",
                  padding: "0 10px",
                  border: "1px solid #058AEE",
                }}
                label="View"
                isColor={true}
                textColor="#058AEE"
                removeBackGround={true}
                onClick={() =>
                  onViewClick(
                    item?.case_id,
                    item?.status,
                    item?.assigned_to_current_user
                  )
                }
              />
            ),
          }));
          setSearchTableData(newData);
          setCount(searchDetails?.totalCases || 10);
        }
      })
      ?.catch((err) => {
        setShowSkeleton(false);
        setSearchTableData([]);
        showToast(err?.response?.data?.message, "error", true);
      });
  }, []);

  const debouncedSearch = useCallback(debounce(searchApicall, 1500), []);

  useEffect(() => {
    let newData = searchDetails?.caseList?.map((item, index) => ({
      ...item,
      srNo: index + 1,
      view: (
        <CommonButton
          sx={{
            fontSize: "10px",
            padding: "0 10px",
            border: "1px solid #058AEE",
          }}
          label="View"
          isColor={true}
          textColor="#058AEE"
          removeBackGround={true}
          onClick={() =>
            onViewClick(
              item?.case_id,
              item?.status,
              item?.assigned_to_current_user
            )
          }
        />
      ),
    }));
    setSearchTableData(newData);
    setCount(searchDetails?.totalCases || 0);
    setShowSkeleton(true);
    debouncedSearch(searchSource, searchType, searchValue, page);
    return () => debouncedSearch.cancel();
  }, [searchValue, searchSource, searchType, page]);

  useEffect(() => {
    return () => dispatch(setPage(1));
  }, []);

  return (
    <div className={style["case_search_Container"]}>
      <div className={style["case_search_header_container"]}>
        <img
          height="20"
          className={style["backArrow_Image"]}
          src={backArrowBold}
          alt="backArrow"
          onClick={onBackClick}
        />
        <h1
          className={style["case_search_header"]}
          style={{ fontSize: "1.4rem", color: "#737D8C" }}
        >
          Search result for {searchValue}
        </h1>
      </div>
      <div style={{ marginTop: "20px" }}>
        {!showSkeleton ? (
          <TableComponent
            stickyHeader={false}
            columnHeaderBackgroundColor={"#FCF7FF"}
            columnHeaderColor={"#242424"}
            columnHeaderFontWeight={600}
            columnBodyFontWeight={400}
            page={page}
            rowsPerPage={rowsPerPage}
            count={count}
            firstButtonClicked={firstButtonClicked}
            lastButtonClicked={lastButtonClicked}
            handleNextButtonClick={handleNextButtonClick}
            handleBackButtonClick={handleBackButtonClick}
            onPageDropdownChange={onPageDropdownChange}
            setPage={(value) => dispatch(setPage(Number(value)))}
            rowsData={searchTableData}
            columnsData={CaseSearchData?.[0]?.column}
            activeMenu="caseManagement"
            hideBorders={true}
            isStandardTable={true}
          />
        ) : (
          <TableSkeleton />
        )}
      </div>
    </div>
  );
}

export default CaseSearchTable;
